import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import priorities from '../../data/priorities';
import PriorityBox from './PriorityBox';
import WorkList from './WorkList';
import { AGENDADA } from '../../data/audienceStates';
import { listWorkListAction, listAudiencesAction } from '../../actions/audiencesActions';
import { PROFILE_JUEZ_IMPUGNACION, PROFILE_OGA, PROFILE_SISTEMAS } from '../../data/profiles';


const Dashboard = () => {
    
    // Inicializo el dispatch
    const dispatch = useDispatch();
    
    // Traigo el store
    const actualPage = useSelector((state) => state.audiences.workListActualPage);
    const audiences = useSelector( state => state.audiences.audiencesWorkList );
    const audiencesStore = useSelector( state => state.audiences.audiences );
    const authUser = useSelector( state => state.auth.user );
    const isFirst = useSelector((state) => state.audiences.workListIsFirst);
    const isLast = useSelector((state) => state.audiences.workListIsLast);
    const totalPages = useSelector((state) => state.audiences.workListTotalPages);

    // Manejo las funciones
    const handleSearch = parameters => {
        loadAudiences(parameters);
    }

     // Carga inicial
    const loadAudiences = (parameters) => {
        //Verifico q esté logueado
        if(authUser)
        {   // Si es OGA, llamo al listado de trabajo
            if(authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS)
            {   dispatch( listWorkListAction(parameters || {} ));
            }
            else
            {   const today = moment().format("YYYY-MM-DD");

                // Seteo parámetros
                let paramsInit = {
                    start_date_from: `equals:${today}T00:00:00`,
                    start_date_to: `equals:${today}T23:59:59`,
                    status_id: `equals:${AGENDADA}`,
                };
                if (parameters) {
                    const { page, paging, size } = parameters;
                    paramsInit = {
                        ...paramsInit,
                        page,
                        paging,
                        size,
                    };
                }

                // Si es juez 
                if(authUser.perfil.id === PROFILE_JUEZ_IMPUGNACION){
                    paramsInit.search += `,juezImpugnacion:${authUser.id}`
                }
                // Busco las audiencias
                dispatch( listAudiencesAction(paramsInit) );
            }
        }
    }
    
    // Cargo las audiencias al inicio
    useEffect(() => {
        loadAudiences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authUser]);

    // Renderizo
    return (
        <React.Fragment>
            {   authUser && (audiences || audiencesStore) ? (
                    <React.Fragment>                        
                        {   authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS ? (
                                <div className="row">
                                    {   priorities.map(priority => (
                                            <PriorityBox
                                                audiences={audiences || audiencesStore}
                                                key={`priority${priority.id}`}
                                                priority={priority}
                                            />
                                        ))
                                    }
                                </div>
                            ) : null
                        }
                        <div className="row">
                            <WorkList
                                actualPage={actualPage}
                                audiences={authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS ? audiences : audiencesStore}
                                authUser={authUser}
                                handleSearch={handleSearch}
                                isFirst={isFirst}
                                isLast={isLast}
                                totalPages={totalPages}
                            />
                        </div>
                    </React.Fragment>
                ) : null
            }
        </React.Fragment>
    );
};

export default Dashboard;